<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'115px'" :get-action="queryApi" :serial="serial" :before-query-search="beforeQuerySearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <!-- 客户名称 -->
          <el-col v-if="!$store.getters.cusId" :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="cusCode">
              <BjSelectLov v-model="queryParams.cusCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" />
            </el-form-item>
          </el-col>

          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessBatchInventoryQuery.table.skuCode')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessBatchInventoryQuery.table.skuCode')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
           <!-- 批次号 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.form.batchCode')" prop="batchNum">
              <BjInput v-model="queryParams.batchNum" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessPurchaseOrder2.form.batchCode')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <span v-else-if="col.prop === 'stockNum'">{{ (scope.row.stockNum).toFixed(0) }}</span>
                <span v-else-if="col.prop === 'preemptionNum'">{{ (scope.row.preemptionNum + scope.row.lockNum).toFixed(0) }}</span>
                <span v-else>{{ scope.row[col.prop] | timeFilters({isSession:false, dateFormat:'DD/MM/YYYY'}) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" align="center">
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  const getDefaultForm = () => {
    return {};
  };
  
  export default {
    name: 'BusinessBatchInventoryQuery',
    mixins: [pageMiXin],
    data() {
      return {
        queryApi: orderApi.thirdAdapter,
        colSpan: 4,
        // 查询参数
        queryParams: {
          cusCode: this.$store.getters.userInfo.clientCode || null,
          skuCode:null,
          batchNum:null,
        },
        // 表单参数
        form: getDefaultForm(),
        // 表单校验
        rules: {},
        labelsVersion: 11,
        labelList1: [
          { label: this.$t('BusinessBatchInventoryQuery.table.skuCode'), prop: 'standardSkuCode', isCheck: true, disabled: false },
          { label: this.$t('BjDialogListConfig.SKUname'), prop: 'productName', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.usableNum2'), prop: 'usableNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.stockNum2'), prop: 'stockNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.lockNum2'), prop: 'preemptionNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessPurchaseOrder2.form.batchCode'), prop: 'batchNum', isCheck: true, disabled: false},
          { label: this.$t('BusinessBatchInventoryQuery.table.expirationDate'), prop: 'bbd', isCheck: true, disabled: false},
        ],
        labelList2: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.skuCode'), prop: 'standardSkuCode', isCheck: true, disabled: false },
          { label: this.$t('BjDialogListConfig.SKUname'), prop: 'productName', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.usableNum2'), prop: 'usableNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.stockNum2'), prop: 'stockNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessBatchInventoryQuery.table.lockNum2'), prop: 'preemptionNum', isCheck: true, disabled: false },
          { label: this.$t('BusinessPurchaseOrder2.form.batchCode'), prop: 'batchNum', isCheck: true, disabled: false},
          { label: this.$t('BusinessBatchInventoryQuery.table.expirationDate'), prop: 'bbd', isCheck: true, disabled: false},
        ],
      };
    },
    computed: {
      labelList() {
        if (this.$store.getters.cusId) {
          return this.labelList1;
        } else {
          return this.labelList2;
        }
      },
    },
    watch: {},
  };
  </script>
  <style scoped>
  ::v-deep .bj-page .el-form-item__label {
    display: none;
  }
  </style>
  